import React, { useEffect } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Stack, Typography } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { useState } from 'react'
import { bookingType1, chargeType1, fixedCharge } from '../../GSConstants'
import { PaymentTypesOptions } from '../../../../common/constants'
import Lineinput from '../../../../common/lineinput'
import { updateDemurrageChrg } from '../../../../../store/generalSetting/GSAction'
import * as mdt from '../../../../common/modaltypes'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import { focusElemnt, isNull, navigation1, navigation3 } from '../../../../common/helper'

const DemurrageChrgModal = (props) => {
  const {
    data: { common },
    updateModal,
    updateAlertError,
    getDemurrageChrg,
    updateDemurrageChrg,UseToPayAsCOD
  } = props
  const { loginData, cnsgnmntTypes } = common
  const { propsData, getDemurrageChrgList } = props
  const { headText, isUpdate, existingData } = propsData
  const [selConsignmentType, setSelConsignmentType] = useState({})
  const [selBookingType, setSelBookingType] = useState({})
  const [selChargeType, setSelChargeType] = useState({})
  const [selPaymentType, setSelPaymentType] = useState({})
  const [selFixChrg, setSelFixChrg] = useState({ id: 0, name: 'No' })
  const [afterDyas, setAfterDyas] = useState(0)
  const [demmurageChrg, setDemmurageChrg] = useState(0)
  const [isMaxDemurrageChrg, setIsMaxDemurrageChrg] = useState(true)
  const [isActive, setIsActive] = useState(false)
  const [maxDemmurageChrg, setMaxDemmurageChrg] = useState(0)

  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    focusElemnt('addEdit_Booking_Type')
  }, [])
  useEffect(() => {
    if (isUpdate) {
      setSelBookingType({ id: 1, name: 'Own Bookings' })
      setSelChargeType({ id: existingData?.ChargeTypeID, name: existingData?.ChargeTypeDesc })
      setSelConsignmentType({ ConsignmentSubTypeID: existingData?.ConsignmentSubTypeID, SubType: existingData?.SubType })
      setSelPaymentType({ id: existingData?.PayTypeID, Name: existingData?.PaymentType })
      setSelFixChrg({ id: existingData?.IsFixed === 'NO' ? 0 : 1, name: existingData?.IsFixed === 'NO' ? 'No' : 'Yes' })
      setAfterDyas(existingData?.AfterDays)
      setDemmurageChrg(existingData?.DemurrageCharge)
      setIsMaxDemurrageChrg(existingData?.IsMaxDemurrageChg === 'NO' ? false : true)
      setIsActive(existingData?.IsActive === 1 ? true : false)
      setMaxDemmurageChrg(existingData?.MaxDemurrageChg)
    }
  }, [isUpdate])

  const handleSaveAndUpdateDemurrageChrg = () => {
    let allConsignmentIds, commaSeparatedConsignmentIds, allPaymentIds, commaSeparatedPaymentIds
    if (selConsignmentType?.ConsignmentSubTypeID === 0) {
      allConsignmentIds = cnsgnmntTypes?.map((item) => item.ConsignmentSubTypeID)
      commaSeparatedConsignmentIds = allConsignmentIds.join(', ')
    }
    if (selPaymentType?.id === 0) {
      allPaymentIds = PaymentTypesOptions?.map((item) => item.id)
      commaSeparatedPaymentIds = allPaymentIds.join(', ')
    }
    const body = {
      CompanyID: loginData?.intCompanyID,
      UserID: loginData?.intUserID,
      ConsignmentType:
        selConsignmentType?.ConsignmentSubTypeID === 0
          ? commaSeparatedConsignmentIds
          : (selConsignmentType?.ConsignmentSubTypeID).toString(),
      PayTypeID: selPaymentType?.id === 0 ? commaSeparatedPaymentIds : (selPaymentType?.id).toString(),
      DemurrageCharge: demmurageChrg,
      IsActive: isActive ? 1 : 0,
      DemChargeType: selChargeType?.id,
      Days: afterDyas,
      IsFixed: selFixChrg?.id,
      Mode: selBookingType?.id,
      IsMaxDemChgSet: isMaxDemurrageChrg ? 1 : 0,
      MaxDemurrageChg: maxDemmurageChrg,
    }
    updateDemurrageChrg(body)
      .then((res) => {
        if (res.status === 'Success') {
          updateModal(true, mdt.demurrageChrgConfModal)
          getDemurrageChrgList()
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
        }
      })
      .catch((err) => {
        console.log('Error:', err)
      })
  }
  return (
    <Modal
      headTxt={headText}
      width={'60%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Stack className="GSConsTypeModal" style={{ padding: '16px' }}>
        <Grid container style={{ padding: '0px', justifyContent: 'space-between' }}>
          <Grid item xs={6} md={2.8}>
            <DropDownOA
              id={'addEdit_Booking_Type'}
              label={'Booking Type'}
              data={bookingType1}
              defaultvalue={selBookingType?.name}
              idKey={`id`}
              dataKey={`name`}
              width="100%"
              nextId={'addEdit_Charge_Type'}
              onSelect={(val) => {
                setSelBookingType(val)
              }}
            />
          </Grid>
          <Grid item xs={6} md={2.8}>
            <DropDownOA
              id={'addEdit_Charge_Type'}
              label={'Charge Type'}
              data={chargeType1}
              idKey={`id`}
              dataKey={`name`}
              defaultvalue={selChargeType?.name}
              width="100%"
              nextId={'addEdit_Consignment_Type'}
              prevId={`addEdit_Booking_Type`}
              onSelect={(val) => {
                setSelChargeType(val)
              }}
            />
          </Grid>
          <Grid item xs={6} md={2.8}>
            <DropDownOA
              id={'addEdit_Consignment_Type'}
              label={'Select Consignment Type'}
              // data={cnsgnmntTypes}
              data={cnsgnmntTypes.length > 0 ? [{ ConsignmentSubTypeID: 0, SubType: 'All' }, ...cnsgnmntTypes] : []}
              defaultvalue={selConsignmentType?.SubType}
              onSelect={(val) => {
                setSelConsignmentType(val)
              }}
              idKey={`ConsignmentSubTypeID`}
              dataKey={`SubType`}
              width="100%"
              prevId={`addEdit_Charge_Type`}
              nextId={'addEdit_Payment_Type'}
            />
          </Grid>
          <Grid item xs={6} md={2.8}>
            <DropDownOA
              id={'addEdit_Payment_Type'}
              label={'Payment Type'}
              // data={PaymentTypesOptions}
              data={(PaymentTypesOptions).map((item) => {
                if (UseToPayAsCOD === 1) {
                  if (item.id === 2) {
                    return { ...item, Name: 'COD' };
                  }
                  if (item.id === 7) {
                    return { ...item, Name: 'COD Manual' };
                  }
                  if (item.id === 9) {
                    return { ...item, Name: 'COD DDDV' };
                  }
                  if (item.id === 4) {
                    return null;
                  }
                }
                return item;
              }).filter(Boolean)
              }
              defaultvalue={selPaymentType?.Name}
              dataKey={`Name`}
              idKey={`id`}
              width="100%"
              nextId={'fixed_charge'}
              prevId={`addEdit_Consignment_Type`}
              onSelect={(val) => {
                setSelPaymentType(val)
              }}
            />
          </Grid>
        </Grid>
      </Stack>
      <Stack className="GSConsTypeModal" style={{ padding: '16px' }}>
        <Grid container style={{ padding: '0px' }}>
          <Grid item xs={6} md={2.6}>
            <Box sx={{ paddingLeft: '0px', paddingRight: '16px' }}>
              <DropDownOA
                id="fixed_charge"
                defaultvalue={selFixChrg?.name}
                data={fixedCharge}
                width="100%"
                searchPlaceholder={`Search Fixed Charge`}
                label={'Fixed Charge'}
                dataKey={`name`}
                idKey={`id`}
                onSelect={(value) => setSelFixChrg(value)}
                nextId={'after_days'}
                prevId={'addEdit_Payment_Type'}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={2.6}>
            <Box sx={{ paddingLeft: '0px', paddingRight: '16px' }} className={'input--wrapper'}>
              <Lineinput
                id={'after_days'}
                label={`After Days`}
                type="text"
                name="After Days"
                value={afterDyas}
                sx={{ margin: '8px', width: '100%' }}
                onChange={(e) => setAfterDyas(e.target.value)}
                onKeyDown={(e) => navigation1(e, 'demurrage_chrg', 'fixed_charge')}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={2.6}>
            <Box sx={{ paddingLeft: '0px', paddingRight: '16px' }} className={'input--wrapper'}>
              <Lineinput
                id={'demurrage_chrg'}
                label={`Demurrage Charge`}
                type="text"
                name="Demurrage Charge"
                value={demmurageChrg}
                sx={{ margin: '8px', width: '100%' }}
                onChange={(e) => setDemmurageChrg(e.target.value)}
                onKeyDown={(e) => navigation1(e, 'is_max_demurrage_chrg', 'after_days')}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={3.0} style={{ marginLeft: 'auto' }}>
            <Box>
              <FormControlLabel
                id="is_max_demurrage_chrg"
                value="end"
                checked={isMaxDemurrageChrg}
                onChange={(e) => setIsMaxDemurrageChrg(!isMaxDemurrageChrg)}
                control={<Checkbox />}
                label={
                  <Typography variant="h6" sx={{ fontWeight: '600', lineHeight: '18px', margin: '0px' }}>
                    Max. Demurrage Charge
                  </Typography>
                }
                labelPlacement="end"
                onKeyDown={(e) => navigation1(e, 'max_demurrage', 'demurrage_chrg')}
              />
            </Box>
          </Grid>
          <Grid item xs={6} md={1.1}>
            <Box sx={{ paddingX: '0px' }} className={'input--wrapper'}>
              <Lineinput
                id={'max_demurrage'}
                label={''}
                type="text"
                name=""
                value={maxDemmurageChrg}
                sx={{ margin: '8px', width: '100%' }}
                onChange={(e) => setMaxDemmurageChrg(e.target.value)}
                onKeyDown={(e) => navigation1(e, 'activeDemurrageCharge', 'is_max_demurrage_chrg')}
              />
            </Box>
          </Grid>
        </Grid>
      </Stack>
      <Divider />
      <Box sx={{ display: 'flex', justifyContent: 'end', padding: '16px' }}>
        <Item>
          <FormControlLabel
            id="activeDemurrageCharge"
            onChange={(e) => {
              setIsActive(e.target.checked)
            }}
            control={<Checkbox checked={isActive} />}
            label={
              <Typography variant="h6" sx={{ fontWeight: '600' }}>
                Active Demurrage Charge
              </Typography>
            }
            onKeyDown={(e) => navigation1(e, 'save_update_btn', 'max_demurrage')}
          />
        </Item>
        <Item className="disabled-wrapper" style={{ padding: '0px' }}>
          <Button
            id={'save_update_btn'}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
            onClick={handleSaveAndUpdateDemurrageChrg}
            onKeyDown={(e) => navigation3(e, 'addEdit_Booking_Type', 'activeDemurrageCharge', () => {})}
            disabled={
              Object.keys(selBookingType).length === 0 ||
              Object.keys(selChargeType).length === 0 ||
              Object.keys(selConsignmentType).length === 0 ||
              Object.keys(selPaymentType).length === 0
            }
          >
            {isUpdate ? 'UPDATE' : 'SAVE'}
          </Button>
        </Item>
      </Box>
    </Modal>
  )
}

//export default DemurrageChrgModal
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
  updateAlertError,
  updateDemurrageChrg,
}

export default connect(mapStateToProps, mapDispatchToProps)(DemurrageChrgModal)
